import $ from 'jquery';
import formatBanners from './formatBanners';

export default () => {
  $(document).on('shopify:section:load', (e) => {
    formatBanners(`[data-section-id="${e.detail.sectionId}"]`);
  });
};